module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "tochead"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('h2', {
    staticClass: "toc_top"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction"
    }
  }, [_c('span', {
    staticClass: "sfont"
  }, [_vm._v("INTRODUCTION")])]), _c('br'), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter_1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART X")]), _vm._v(" Face-to-Face with the Soviet Steamroller")]), _c('br'), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter_2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART XI")]), _vm._v(" The Mediterranean Front")]), _c('br'), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART XII")]), _vm._v(" The West: From One Landing to the Next")]), _c('br'), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART XIII")]), _vm._v(" Second Line and Training Units")]), _c('br'), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART XIV")]), _vm._v(" The Eagle Falls")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a03f5252","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 72
// module chunks = 0